import React from 'react'

interface InviteLinkProps {
  style?: object
  fill?: string
  width?: string
  className?: string
  viewBox?: string
}

const InviteLink = ({
  style = {},
  fill = '#707070',
  width = '18px',
  className = '',
  viewBox = '0 0 18 18'
}: InviteLinkProps) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill={fill}
      d="M13.3077 1C12.3212 1 11.395 1.3845 10.6971 2.08173L9.46635 3.3125C8.76912 4.01035 8.38462 4.93662 8.38462 5.92308C8.38462 6.70109 8.62671 7.43937 9.06971 8.0601L8.0601 9.06971C7.4393 8.62692 6.70062 8.38462 5.92308 8.38462C4.93662 8.38462 4.01035 8.76912 3.3125 9.46635L2.08173 10.6971C1.3845 11.395 1 12.3212 1 13.3077C1 14.2942 1.3845 15.2204 2.08173 15.9183C2.77896 16.6161 3.70585 17 4.69231 17C5.67877 17 6.60504 16.6155 7.30289 15.9183L8.53365 14.6875C9.23088 13.9897 9.61539 13.0634 9.61539 12.0769C9.61539 11.7378 9.56695 11.4071 9.47957 11.0889L8.3726 12.1959C8.34429 12.7861 8.11269 13.3675 7.66346 13.8173L6.43269 15.0481C5.47269 16.0081 3.91131 16.0081 2.95192 15.0481C1.99254 14.0881 1.99192 12.5267 2.95192 11.5673L4.18269 10.3365C4.66269 9.85654 5.29351 9.61779 5.92428 9.61779C6.35613 9.61779 6.78378 9.73794 7.16707 9.96274L5.48798 11.6418C5.42892 11.6985 5.38177 11.7665 5.34928 11.8416C5.3168 11.9168 5.29964 11.9976 5.29881 12.0795C5.29797 12.1614 5.31348 12.2426 5.34443 12.3184C5.37538 12.3942 5.42114 12.4631 5.47904 12.521C5.53693 12.5789 5.60579 12.6246 5.6816 12.6556C5.7574 12.6865 5.83861 12.702 5.92048 12.7012C6.00236 12.7004 6.08324 12.6832 6.15839 12.6507C6.23355 12.6182 6.30147 12.5711 6.35817 12.512L12.512 6.35817C12.6009 6.27173 12.6617 6.16045 12.6863 6.0389C12.7109 5.91735 12.6982 5.7912 12.6498 5.677C12.6015 5.56279 12.5198 5.46585 12.4154 5.39888C12.311 5.3319 12.1889 5.29803 12.0649 5.30168C11.905 5.30645 11.7533 5.37326 11.6418 5.48798L9.96274 7.16707C9.40816 6.22361 9.52751 4.99121 10.3365 4.18269L11.5673 2.95192C12.0473 2.47192 12.6769 2.23317 13.3077 2.23317C13.9385 2.23317 14.5681 2.47254 15.0481 2.95192C16.0081 3.91192 16.0081 5.47331 15.0481 6.43269L13.8173 7.66346C13.3681 8.11269 12.7861 8.34429 12.1959 8.3726L11.0889 9.47957C11.4071 9.56695 11.7378 9.61539 12.0769 9.61539C13.0634 9.61539 13.9897 9.23088 14.6875 8.53365L15.9183 7.30289C16.6155 6.60504 17 5.67877 17 4.69231C17 3.70585 16.6155 2.77958 15.9183 2.08173C15.2204 1.3845 14.2942 1 13.3077 1Z"
    />
  </svg>
)

export default InviteLink
